import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import { getFilterShipAPI, updateFilterShipAPI, uploadShipMoveInfoAPI } from './api';
import { filterShip, filterShipSuccess, updateShip, updateShipSuccess, uploadShipMove } from './slice';

function* filterShipSaga({ payload }: any) {
  const { filterParam, filterShipSuccessLocal, filterShipFailLocal } = payload;

  try {
    const response: ResponseGenerator = yield call(getFilterShipAPI, filterParam);
    yield put(filterShipSuccess(response));
    filterShipSuccessLocal(response?.data);
  } catch (error) {
    filterShipFailLocal();
  }
}

function* updateShipSaga({ payload }: any) {
  const { onSucess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(updateFilterShipAPI, data);
    yield put(updateShipSuccess(response));
    onSucess();
  } catch (error) {
    onFail();
  }
}

function* uploadShipMoveSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(uploadShipMoveInfoAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* watchAirMaster() {
  yield takeEvery(filterShip, filterShipSaga);
  yield takeLatest(updateShip, updateShipSaga);
  yield takeLatest(uploadShipMove, uploadShipMoveSaga);
}

export default watchAirMaster;
